export const loadImage = (url: string) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = resolve;
  img.onerror = reject;
  img.src = url;
});

export const loadImageUntilSuccess = async (tmpImage: string) => {
  const maxAttempts = 6;
  let attempt = 0;

  while (attempt < maxAttempts) {
    try {
      // eslint-disable-next-line no-await-in-loop
      await loadImage(tmpImage);
      return; // ✅ Image chargée
    } catch (error) {
      attempt += 1;
      if (attempt >= maxAttempts) {
        break;
      }
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  }
};
